export default __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightItalic.82bfefed.ttf";